export enum HarborCapability {
  // 5.1 Harbour – Discovery & Maps
  DISCOVERY_LISTED_IN_MAP_AND_SEARCH = 'harbor.discovery.listed_in_map_and_search',
  DISCOVERY_MANAGE_BASIC_PROFILE = 'harbor.discovery.manage_basic_profile',
  DISCOVERY_MANAGE_AMENITIES_AND_SERVICES = 'harbor.discovery.manage_amenities_and_services',
  DISCOVERY_MANAGE_PHOTOS = 'harbor.discovery.manage_photos',
  DISCOVERY_PROMOTED_PLACEMENT_BASIC = 'harbor.discovery.promoted_placement_basic',

  // 5.2 Harbour – Navigation & Routing
  NAVIGATION_ROUTING_TARGET_FOR_BOATERS = 'harbor.navigation.routing_target_for_boaters',

  // 5.3 Harbour – Bookings & Payments
  BOOKINGS_MANAGE_BOOKABLES = 'harbor.bookings.manage_bookables',
  BOOKINGS_ACCEPT_ONLINE_BOOKINGS = 'harbor.bookings.accept_online_bookings',
  BOOKINGS_MANAGE_BOOKING_REQUESTS = 'harbor.bookings.manage_booking_requests',
  BOOKINGS_REPORTS_BASIC = 'harbor.bookings.reports_basic',
  BOOKINGS_REPORTS_EXPORT_CSV = 'harbor.reports.finance_export_csv',
  BOOKINGS_MANAGEMENT_EXPORT_CSV = 'harbor.bookings.export_csv',
  BOOKINGS_ADDONS = 'harbor.addons.manage',

  // 5.4 Harbour – Personalisation & Favourites
  ALERTS_STANDARD_ALERTS = 'harbor.alerts.standard_alerts',

  // 5.6 Harbour – Account, Data & Support
  ACCOUNT_FINANCIAL_STATEMENTS_BASIC = 'harbor.account.financial_statements_basic',

  // 5.7 Harbour – Piers Management
  PIERS_MANAGE_PIERS = 'harbor.piers.berth_pier_management',

  // inventory
  INVENTORY_MANAGE_BERTHS = 'harbor.inventory.manage_berths',
  INVENTORY_MANAGE_PIER = 'harbor.inventory.manage_pier',
  INVENTORY_MANAGE_CATEGORIES = 'harbor.inventory.manage_categories',

  //Availability
  AVAILABILITY_MANAGE = 'harbor.availability.availability_calendar',

  //POI
  POIS_MANAGE = 'harbor.pois.manage',
  POIS_MANAGE_REQUESTS = 'harbor.pois.manage_requests',

  //Services — Manage Services
  // Services — Manage Service Bookings
  // Services — Manage Service Requests

  SERVICES_MANAGE_SERVICES = 'harbor.services.manage_services',
  SERVICES_MANAGE_BOOKINGS = 'harbor.services.manage_bookings',
  SERVICES_MANAGE_REQUESTS = 'harbor.services.manage_requests',

  // Associations — Manage Club Association Requests
  ASSOCIATIONS_MANAGE_CLUB_ASSOCIATIONS = 'harbor.associations.manage_club_associations',

  // Tourism Highlights
  TOURISM_HIGHLIGHTS_MANAGE = 'harbor.discovery.manage_tourism_highlights',
}
